import { NotificationsListPage } from "./NotificationsListPage";

export default function ResellerNotificationsPage() {
  return <NotificationsListPage showCreate={false} />;
}
